module.exports = __webpack_public_path__ + "media/newstyle/images/icon-apple-dcaa52147f8764fd8da3ea489ffcad38.svg";